import React from 'react';
import { Progress } from 'antd';

const ProgressBar = ({ noOfUsers, totalUsers, color, level }) => {
  return (
    <div className="progress-bar mb-3">
      <div className="flex mb-1 justify-between">
        <span className="text-sm text-grey">
          {noOfUsers} of <b>{isNaN(totalUsers) ? 0 : totalUsers}</b>
        </span>
        <span className="text-sm font-semibold text-grey">Level {level} Users</span>
      </div>
      <Progress
        size={['default', 12]}
        strokeColor={color}
        percent={Math.floor((noOfUsers / totalUsers) * 100)}
        showInfo={false}
      />
    </div>
  );
};

export default ProgressBar;
